import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import DocumentRow from './DocumentRow';
import TableCheckbox from './TableCheckbox';
import { PsTable } from './table/PsTable';

export default class DocumentsTable extends React.Component {

    renderHead() {
        const {
            hideOutsource,
            displayContractorColumn,
            checkedAll = false,
            onCheckAll,
            onUncheckAll,
            isContractorViewer
        } = this.props;

        const displayCheck = !!onCheckAll && !!onUncheckAll;

        return (
            <tr>
                {
                    displayCheck && (
                        <th>
                            <TableCheckbox
                                checked={checkedAll}
                                onChange={checkedAll ? onUncheckAll : onCheckAll}
                            />
                        </th>
                    )
                }
                <th>{I18nUtils.tr('TR_ESTADO')}</th>
                {
                    (displayContractorColumn || isContractorViewer) && <th>{I18nUtils.tr('TR_CONTRATISTA')}</th>
                }
                {
                    !hideOutsource && <th>{I18nUtils.tr('TR_SUBCONTRATA')}</th>
                }
                <th>{I18nUtils.tr('TR_NOMBRE_DOCUMENTO')}</th>
                <th>{I18nUtils.tr('TR_FECHA_DOCUMENTO')}</th>
                <th>{I18nUtils.tr('TR_CADUCIDAD')}</th>
                <th>{I18nUtils.tr('TR_ACCESO_FICHA')}</th>
            </tr>
        );
    }

    render() {
        const {
            error,
            data,
            hideOutsource,
            displayContractorColumn,
            checkedItemIds,
            onCheck,
            isContractorViewer
        } = this.props;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        if ( !data || data.length === 0 ) return null;

        return (
            <PsTable headings={this.renderHead()}>
                {
                    data.map((item, i) =>
                        <DocumentRow
                            key={i}
                            hideOutsource={hideOutsource}
                            displayContractorColumn={displayContractorColumn}
                            document={item}
                            checkedItemIds={checkedItemIds}
                            onCheck={onCheck}
                            isContractorViewer={isContractorViewer}
                        />,
                    )
                }
            </PsTable>
        );
    }

}

DocumentsTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
    hideOutsource: PropTypes.bool,
    displayContractorColumn: PropTypes.bool,
    isContractorViewer: PropTypes.bool,
};

DocumentsTable.defaultProps = {
    hideOutsource: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/DocumentsTable.jsx